<script setup lang="ts">
// The navy proof strip that closes every page in the mockups.
//
// The mockups open this bar with "4.9/5 Customer Rating · 500+ Google
// Reviews". That is out for good, not gated behind a constant (open-items
// review, item 3): the site has no review history of its own, and the only
// ratings available to borrow belong to somebody else's business. If
// Ask-HVAC.com ever earns its own listing, this is where it would go — but
// it would be new code with a real source behind it, not a placeholder
// sitting here inviting a number.
//
// What's left are four claims about how the service works, each of which
// the site can be held to today.
const CLAIMS = [
    {
        title: 'Trusted HVAC Guidance',
        icon: '<path d="M12 2 3.5 5.5v6c0 5 3.6 9.4 8.5 10.5 4.9-1.1 8.5-5.5 8.5-10.5v-6z"/>',
    },
    {
        title: 'Independent & Unbiased',
        icon: '<path d="M12 3v18M4 8h16M6.5 8 3 15h7zM17.5 8 14 15h7z"/>',
    },
    {
        title: 'Save Energy & Money',
        icon: '<path d="M13 2 4 14h6l-1 8 9-12h-6z"/>',
    },
    {
        title: 'Make the Right Decision',
        icon: '<path d="M12 3 2 11h3v9h5v-6h4v6h5v-9h3z"/>',
    },
]
</script>

<template>
    <section class="trust-bar">
        <div class="inner">
            <div v-for="claim in CLAIMS" :key="claim.title" class="item">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true" v-html="claim.icon"></svg>
                <div class="text"><strong>{{ claim.title }}</strong></div>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
.trust-bar {
    background: var(--site-navy);
    color: #fff;
}

.inner {
    max-width: var(--site-content-max);
    margin: 0 auto;
    padding: var(--site-space-md) var(--site-space-lg);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--site-space-md);
}

.item {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    flex: 1 1 auto;
    justify-content: center;
    padding: 0.2rem var(--site-space-md);
    border-left: 1px solid rgba(255, 255, 255, 0.16);

    &:first-child {
        border-left: none;
    }
}

.icon {
    width: 1.55rem;
    height: 1.55rem;
    flex-shrink: 0;
    color: #fff;
}

.text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;

    strong {
        font-size: 0.85rem;
        font-weight: 600;
    }
}

@media (max-width: 820px) {
    .item {
        flex: 1 1 45%;
        border-left: none;
        justify-content: flex-start;
    }
}
</style>
